<template>
  <button class="btn" type="button" :class=iconName :style="styleObject" @click="onClicked"></button>
</template>

<script>
export default {
  name: "Button",
  data()
  {
    return {
      styleObject: {
        fontSize: this.iconSize
      }
    };
  },
  props: {
    iconName: String,
    iconSize: {
      type: String,
      default: "1rem"
    }
  },
  computed: {
    /*
    getIcon() {
        switch(button.iconName) {
            case "fa-plus":
                return {}
                break;
        }

    }

     */
  },
  methods: {
    onClicked()
    {
      this.$emit("clicked");
    }
  }
}
</script>

<style lang="scss" scoped>
button
{
  background-color: $primary-blue;
  color: $font-light;

  width: 50px;
  height: 50px;
  border-radius: 5px;
}
</style>